import { EMPTY_WORK_ORDER_CONFIG, WorkOrderConfig } from './types';

export interface RawWorkOrder {
  id: string;
  orderID: string;
  displayName?: string | null;
  index?: string;
  isReady?: boolean;
  status?: string;
  isBuilt?: boolean;
  description?: string;
  // Identity / dimensions
  unitName?: string;
  width?: string;
  height?: string;
  // Inclusion flags
  completeUnit?: boolean;
  buildoutIncluded?: boolean;
  includesHousing?: boolean;
  includesSideTracks?: boolean;
  includesHemBar?: boolean;
  includesFabric?: boolean;
  includesMotorTube?: boolean;
  // Housing
  housingType?: string;
  housingSize?: string;
  // Motor
  motorType?: string;
  driveSide?: string;
  powerCord?: string;
  // Fabric
  fabricType?: string;
  seam?: string;
  fabricHeightAdjustment?: string;
  rotateFabric?: string;
  zipperColor?: string;
  // Hem bar
  hemBarType?: string;
  hemBarCapColor?: string;
  pileBrush?: string;
  // Retention
  retention?: string;
  retentionLeft?: string;
  retentionRight?: string;
  retentionCapColor?: string;
  cutTracks?: boolean;
  // Frame / colors
  frameColorVaries?: boolean;
  frameColor?: string;
  endCapFrameColor?: string;
  buildoutFrameColor?: string;
  hemBarFrameColor?: string;
  housingFrameColor?: string;
  retentionFrameColor?: string;
  // Buildout
  buildoutMaterial?: string;
  buildoutQuantity?: string;
  buildoutLength?: string;
  // Extras
  cfTube?: boolean;
  clearWindow?: boolean;
  clearWindowAmount?: string;
  clearWindowUnit?: string;
  preDrilledTracks?: boolean;
  // Scheduling
  schedulePriority?: string;
  scheduleFrame?: string;
  scheduleFabric?: string;
  // Completion (existing fields, still used by upstream summarisers)
  kittingComplete: boolean;
  fabricComplete: boolean;
  metalComplete: boolean;
  finalAssemblyComplete: boolean;
  woReady?: boolean;
  isTKS0026?: boolean;
}

const str = (v: unknown): string => (v === null || v === undefined ? '' : String(v));
const bool = (v: unknown): boolean => v === true || v === 'T' || v === 'true' || v === 1 || v === '1';

export function buildWorkOrderConfig(wo: RawWorkOrder): WorkOrderConfig {
  return {
    ...EMPTY_WORK_ORDER_CONFIG,
    unitName: str(wo.unitName),
    width: str(wo.width),
    height: str(wo.height),
    completeUnit: bool(wo.completeUnit),
    buildoutIncluded: bool(wo.buildoutIncluded),
    includesHousing: bool(wo.includesHousing),
    includesSideTracks: bool(wo.includesSideTracks),
    includesHemBar: bool(wo.includesHemBar),
    includesFabric: bool(wo.includesFabric),
    includesMotorTube: bool(wo.includesMotorTube),
    housingType: str(wo.housingType),
    housingSize: str(wo.housingSize),
    motorType: str(wo.motorType),
    driveSide: str(wo.driveSide),
    powerCord: str(wo.powerCord),
    fabricType: str(wo.fabricType),
    seam: str(wo.seam),
    fabricHeightAdjustment: str(wo.fabricHeightAdjustment),
    rotateFabric: str(wo.rotateFabric),
    zipperColor: str(wo.zipperColor),
    hemBarType: str(wo.hemBarType),
    hemBarCapColor: str(wo.hemBarCapColor),
    pileBrush: str(wo.pileBrush),
    retention: str(wo.retention),
    retentionLeft: str(wo.retentionLeft),
    retentionRight: str(wo.retentionRight),
    retentionCapColor: str(wo.retentionCapColor),
    cutTracks: bool(wo.cutTracks),
    frameColorVaries: bool(wo.frameColorVaries),
    frameColor: str(wo.frameColor),
    endCapFrameColor: str(wo.endCapFrameColor),
    buildoutFrameColor: str(wo.buildoutFrameColor),
    hemBarFrameColor: str(wo.hemBarFrameColor),
    housingFrameColor: str(wo.housingFrameColor),
    retentionFrameColor: str(wo.retentionFrameColor),
    buildoutMaterial: str(wo.buildoutMaterial),
    buildoutQuantity: str(wo.buildoutQuantity),
    buildoutLength: str(wo.buildoutLength),
    cfTube: bool(wo.cfTube),
    clearWindow: bool(wo.clearWindow),
    clearWindowAmount: str(wo.clearWindowAmount),
    clearWindowUnit: str(wo.clearWindowUnit),
    preDrilledTracks: bool(wo.preDrilledTracks),
    schedulePriority: str(wo.schedulePriority),
    scheduleFrame: str(wo.scheduleFrame),
    scheduleFabric: str(wo.scheduleFabric),
    woStatus: str(wo.status),
    isBuilt: bool(wo.isBuilt),
  };
}
